<template>
  <v-sheet
    fill-height
    align="center"
  >
    <v-card
      color="tertiary"
      class="ma-2"
      :class="mobile ? 'mobilewindow' : 'mainwindow'"
    >
      <template #prepend>
        <div class="text-h3 text-primary pa-1">
          Songbook PDFs
          <v-btn to="/songs">Songs</v-btn>
        </div>
      </template>
      <v-card-title>
        <div class="d-flex fill">
          <History :height="getHeight" />

          <v-text-field
            v-model="search"
            label="Search for Artist or Song"
            prepend-inner-icon="fasldr fa-search"
            :hint="'Results: ' + files.length.toString()"
            clearable
            @update:model-value="doSearch"
            @click:clear="showAll"
          />

          <v-menu>
            <template #activator="{ props }">
              <v-icon-btn
                icon="fasdr fa-label"
                v-bind="props"
              />
            </template>

            <v-list>
              <v-list-item
                v-for="cat in categories"
                :key="cat"
              >
                <v-list-item-title @click="doFilter(cat)">
                  {{ cat }}
                </v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item
                color="error"
                @click="showAll"
              >
                clear
              </v-list-item>
            </v-list>
          </v-menu>

          <v-icon-btn
            v-tooltip:bottom="'Show Indexed Only'"
            icon="fasdr fa-album-collection"
            :active="toggleIndex"
            @click="toggleIndex = !toggleIndex"
          />

          <v-icon-btn
            v-tooltip:bottom="'List Songbooks with Searched Song'"
            icon="fasdr fa-magnifying-glass-music"
            :active="toggleSongSearch"
            @click="toggleSongSearch = !toggleSongSearch"
          />
          <v-icon-btn
            v-tooltip:bottom="'Change Sorting Order'"
            :icon="sortOrder === 'asc'
              ? 'fasdr fa-arrow-down-a-z'
              : 'fasdr fa-arrow-down-z-a'
            "
            @click="changeOrder"
          />
        </div>
      </v-card-title>
      <v-card
        v-if="search !== '' && toggleSongSearch"
        title="Song Found In:"
        density="compact"
        rounded="lg"
        variant="outlined"
        class="mb-3"
      >
        <v-list>
          <v-list-item
            v-for="(album, g) in files"
            :key="g"
            prepend-icon="fasdr fa-album"
            :title="album.name"
            @click="loadbook(files[g].url)"
          />
        </v-list>
      </v-card>
      <v-card-text>
        <v-skeleton-loader
          v-if="appStore.loading"
          type="list-item-two-line, list-item-two-line, list-item-two-line"
        />
        <v-virtual-scroll
          v-else
          :items="files"
          height="calc(100vh - 250px)"
        >
          <template #default="{ item }">
            <v-card
              :key="item.name"

              density="compact"
              class="ma-1"
              color="primary"
            >
              <v-list-item>
                <template #prepend>
                  <v-icon
                    v-if="item.category"
                    :icon="getIcon(item.category)"
                  />
                  <v-icon
                    v-else
                    icon="fasdr fa-album"
                  />
                </template>
                <v-list-item-title
                  v-tooltip:bottom="item.url"
                  @click="loadsong(item.url, 0)"
                >
                  {{ parseTitleArtist(item.name)[0] }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ parseTitleArtist(item.name)[1] || '-' }}
                </v-list-item-subtitle>
                <!-- <v-list-item-title @click="loadsong(item.url, 0)">
                  {{ parseTitle(item.name) }}
                </v-list-item-title> -->
                <template #append>
                  <!-- <div class="d-flex justify-self-end"> -->


                  <v-badge location="left center" :content="item.songs.length">
                    <v-btn
                      v-tooltip:bottom="'Album Tracks List'"
                      icon="fasldr fa-music"
                      :disabled="item.songs.length < 1"
                      @click="showlist(item.name, item.url, item.songs)"
                    />
                   </v-badge>
                  <v-btn
                    v-tooltip:bottom="'Open Songbook'"
                    icon="fasldr fa-book-open"
                    size="sm"
                    @click="loadsong(item.url, 0)"
                  />
                  <v-btn
                    v-tooltip:bottom="'Download Songbook'"
                    icon="fasldr fa-file"
                    size="sm"
                    :href="item.url"
                    target="_new"
                    download
                  />
                  <!-- </div> -->
                </template>
              </v-list-item>
              <v-chip-group v-if="search !== ''">
                <v-chip
                  v-for="chip in showMatched(item.songs || [])"
                  :key="chip.title"
                  v-tooltip:bottom="'Open Song'"
                  color="secondary"
                  @click="item.songs ? loadsong(item.url, item.songs.indexOf(chip) + 1) : null"
                >
                  <template #prepend>
                    <v-avatar
                      class="mr-2"
                    >
                      {{ item.songs ? (item.songs.indexOf(chip) + 1).toString() : '0' }}
                    </v-avatar>
                  </template>
                  {{ chip.title }}
                </v-chip>
              </v-chip-group>
            </v-card>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="showAlbumTracks"
      transition="slide-x-reverse-transition"
    >
      <v-card
        :class="mobile ? 'trackmobile' : 'trackpanel'"
        color="primary"
      >
        <v-card-title class="bg-primary d-flex justify-space-between align-center">
          <span
            v-if="!mobile"
            class="text-h6"
          > {{ parseTitle(albumName) }}</span>

          <v-btn
            icon="fasldr fa-xmark"
            color="error"
            @click="showAlbumTracks = !showAlbumTracks"
          />
        </v-card-title>
        <v-card-text>
          <v-virtual-scroll :items="playlist">
            <template #default="{ item }">
              <v-list-item
                :title="item.title"
                :active="titleMatch(item.title)"
                @click="
                  loadsong(
                    albumUrl,
                    getIndex(item)
                  )
                "
              >
                <template #prepend>
                  <v-avatar
                    tile
                    color="tertiary"
                    class="mr-1"
                  >
                    {{ getIndex(item) }}
                  </v-avatar>
                </template>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="showAlbumTracks = !showAlbumTracks"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script setup lang="ts">
import axios from "axios";
import { useRouter } from "vue-router";
import { ref, computed, onMounted, watchEffect, onBeforeMount } from "vue";
import { useAppStore } from "../stores/app";
import { useDisplay } from "vuetify";
import { type FileDetail, type Song } from "../components/Types";
import History from "../components/History.vue";

const router = useRouter();
const { mobile } = useDisplay();

const appStore = useAppStore();
// const showDrawer = computed(() => {
//   return appStore.drawer;
// });
const toggleSongSearch = ref(false);
const toggleIndex = ref(false);
const toggleAlbum = ref(true);
const showAlbumTracks = ref(false);
// const expand = ref(false);

const files = ref([] as FileDetail[]);
// const search = ref('');
const category = ref('')
const categories = ["game","soundtrack","collection"]
const search = computed({
  get() {
    return appStore.currentSearch;
  },
  set(newVal) {
    appStore.currentSearch = newVal;
  }
})
// const url = ref("");
const sortOrder = ref<"asc" | "desc">("asc");

const sortBy = computed(() => {
  return [{ key: "name", order: sortOrder.value }];
});
const playlist = ref([] as Song[]);
const albumName = ref("");
const albumUrl = ref("");

const getHeight = computed(() => {
  return window.innerHeight;
});

const getTableHeight = computed(() => {
  return window.innerHeight - 80;
});

function titleMatch(val: string) {
  if (search.value === '' || search.value === null) {
    return false;
  } else if (val.replace(/\s+/g, '').toLowerCase().includes(search.value.replace(/\s+/g, '').toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

function changeOrder() {
  if (sortOrder.value === "asc") {
    const newfiles = [...files.value].sort((a, b) => b.name.localeCompare(a.name, 'en'))
    files.value = newfiles
    sortOrder.value = "desc"
  } else {
    const newfiles = [...files.value].sort((a, b) => a.name.localeCompare(b.name, 'en'))
    files.value = newfiles
    sortOrder.value = "asc"
  }

}

function parseTitle(book: string) {
  if (book.includes("-")) {
    return book.replace("-", " ").replace(/\B([A-Z])\B/g, " $1");
  } else {
    return book.replace(/\B([A-Z])\B/g, " $1");
  }
}

function parseTitleArtist(book: string) {
  const barray = [] as string[]
  if (book.includes("-")) {
    const [ta0 = "", ta1 = ""] = book.split("-")
    const at = ta0.replace(/\B([A-Z])\B/g, " $1");
    const bt = ta1.replace(/\B([A-Z])\B/g, " $1");
    barray.push(at, bt)
  } else {
    const lt = book.replace(/\B([A-Z])\B/g, " $1");
    barray.push(lt)
  }

  return barray
}

function getIndex(item: Song) {
  return playlist.value.indexOf(item) + 1;
}
// function toggleDrawer() {
//   if (appStore.drawer) {
//     appStore.drawer = false;
//   } else {
//     appStore.drawer = true;
//   }
// }

function showAll() {
  files.value = appStore.files;
  search.value = '';
}

function loadbook(book: string) {
  const fname = book.replace("https://data.tdot.men/pdf/","")
  appStore.file = appStore.getServerRoot + fname;
  appStore.fileName = fname.replace(".pdf","");
  appStore.currentPage = 1;
  // toggleDrawer();
  router.push({
    path: '/viewer/'+appStore.fileName,
  });
}

function loadsong(book: string, track: number) {
  const fname = book.replace("https://data.tdot.men/pdf/","")
  appStore.file = appStore.getServerRoot + fname;
  appStore.fileName = fname.replace(".pdf","");
  appStore.currentPage = 1;
  appStore.openTrack = track;
  // toggleDrawer();
  router.push({
    path: '/viewer/'+appStore.fileName,
  });
}

function showIndexedOnly() {
  files.value = appStore.showIndexedOnly();
}

function doSearch() {
  if (search.value && search.value !== "" && search.value.length > 1) {
    files.value = appStore.find(search.value);
    appStore.currentSearch = search.value;
  }
}

function doFilter(cat: string) {
  files.value = appStore.files.filter(k => k.category === cat)
}

function showlist(name: string, url: string, songs: Song[]) {
  playlist.value = songs;
  albumName.value = name;
  albumUrl.value = url;
  showAlbumTracks.value = true;
}

function showMatched(songs: Song[]) {
  const s = songs.filter(k => k.title.replace(/\s+/g, '').toLowerCase().includes(search.value.replace(/\s+/g, '').toLowerCase()))


  if (s) {

    return s
  }
}

function getIcon(category: string) {
  switch(category.toLowerCase()) {
    case 'game':
      return "fasdr fa-gamepad-modern"
    case 'soundtrack':
      return "fasdr fa-film"
    case 'collection':
      return "fasdr fa-album-collection"
    default:
      return "fasdr fa-album"
  }
}


watchEffect(() => {
  if (search.value === null || search.value === "") {
    files.value = appStore.files;
    toggleSongSearch.value = false;
    appStore.currentSearch = "";
  }

  if (toggleIndex.value === true) {
    showIndexedOnly();
  }

});

onBeforeMount(async() => {

})


onMounted(async () => {
  appStore.loading = true;
  if (appStore.fileLength === 0) {
    // const newfiles: File[] = [];
    // const data = await axios.get("https://data.tdot.men/pdf/filelist.json");
    try {
    const data = await axios.get(appStore.getServerRoot + 'filelist.json');

    const fileitems = data.data;
    const newfiles = [...fileitems].sort((a, b) => a.name.localeCompare(b.name, 'en'))

    appStore.saveFiles(newfiles);
    files.value = newfiles;
    } catch(err) {
      appStore.setAlert(err);
    }
  } else {
    const newfiles = [...appStore.files].sort((a, b) => a.name.localeCompare(b.name, 'en'))

    files.value = newfiles;
  }

  doSearch();
  appStore.loading = false;

});
</script>

<style lang="css" scoped>
.mainwindow {
  width: 60vw;
  align-self: center;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.mobilewindow {
  width: 95vw;
  align-self: center;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.trackpanel {
  align-self: center;
  width: 60vw;
  background-color: #20213d;
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}

.trackmobile {
  align-self: center;
  width: 95vw;
  background-color: #20213d;
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}
</style>
